import { Box, VisuallyHidden } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import {
  useLottieAnimation,
  type LottieComponentProps,
} from '@leagueplatform/lottie';
import { usePrefersReducedMotion } from '@leagueplatform/web-common';

const animationData = import('assets/journey-delight-overlay.json');

interface JourneyDelightOverlayAnimationProps extends LottieComponentProps {
  shouldPlay?: boolean;
  setShouldPlay?: (shouldPlay: boolean) => void;
}

export const JourneyDelightOverlayAnimation = ({
  lottieConfig: configOverrides,
  shouldPlay,
  setShouldPlay,
}: JourneyDelightOverlayAnimationProps) => {
  const { formatMessage } = useIntl();
  const prefersReducedMotion = usePrefersReducedMotion();
  const lottieConfig = {
    autoplay: true,
    loop: true,
    ...configOverrides,
  };
  const { animation, animationContainerRef } = useLottieAnimation({
    lottieConfig,
    animationData,
  });

  animation?.setSpeed(prefersReducedMotion ? 0.25 : 1);

  const handleAnimationPlayback = () => {
    if (animation?.isPaused) {
      setShouldPlay?.(true);
      animation.play();
    } else {
      setShouldPlay?.(false);
      animation?.pause();
    }
  };

  return (
    <Box
      ref={animationContainerRef}
      onClick={handleAnimationPlayback}
      css={{ opacity: shouldPlay ? 1 : 0.5 }}
    >
      <VisuallyHidden>
        {formatMessage({
          id: 'ANIMATION_ACCESSIBILITY_PLAYBACK',
        } as unknown as Parameters<typeof formatMessage>[0])}
      </VisuallyHidden>
    </Box>
  );
};
